function showMoreResults() {
  // set show more boolean to true to avoid the initial page load variable being set
  this.$data.settings.showMore = true;
  this.$data.settings.showMoreLoading = true;
  this.$data.currentPage++;
  this.filterSearch(true);
}
export default showMoreResults;
